import { render } from "./ProgressCircleScore.vue?vue&type=template&id=1c61ecba&scoped=true"
import script from "./ProgressCircleScore.vue?vue&type=script&lang=js"
export * from "./ProgressCircleScore.vue?vue&type=script&lang=js"

import "./ProgressCircleScore.vue?vue&type=style&index=0&id=1c61ecba&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Anael\\Documents\\developpement\\teachup-video-interactive\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c61ecba"]])

export default __exports__